import { render, staticRenderFns } from "./NeedsSection.vue?vue&type=template&id=71d912ae&scoped=true"
import script from "./NeedsSection.vue?vue&type=script&lang=js"
export * from "./NeedsSection.vue?vue&type=script&lang=js"
import style0 from "./NeedsSection.vue?vue&type=style&index=0&id=71d912ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d912ae",
  null
  
)

export default component.exports